import {
  Component,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn
} from '@angular/forms';
import { CustomerService } from '../shared/services/customer.service';
import { CvBoxChannel } from '../shared/models/cv-box-channels.model';

@Component({
  selector: 'hr-customer-cv-box-channels',
  templateUrl: './customer-cv-box-channels.component.html',
  styleUrls: ['./customer-cv-box-channels.component.less'],
  standalone: false,
})
export class CustomerCVBoxChannelsComponent implements OnChanges {
  @Input() customerId!: number;

  form: FormGroup;
  providerWebsites: CvBoxChannel[] = [];
  isEditMode = false;

  constructor(
    private fb: FormBuilder,
    private customerService: CustomerService
  ) {
    this.form = this.fb.group({
      websites: this.fb.array([], this.atLeastOneCheckedValidator),
    });

    this.form.disable();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['customerId']?.currentValue) {
      this.loadChannels(changes['customerId'].currentValue);
    }
  }

  private loadChannels(customerId: number): void {
    this.websites.clear();

    this.customerService.getCvBoxChannels(customerId).subscribe((response) => {
      this.providerWebsites = response.data.cvBoxProviderSelections;
      this.setWebsites(this.providerWebsites);

      this.form.disable()
    });
  }

  get websites(): FormArray {
    return this.form.get('websites') as FormArray;
  }

  private setWebsites(data: CvBoxChannel[]): void {
    data.forEach(item => {
      this.websites.push(
        this.fb.group({
          providerWebsiteId: [item.providerWebsiteId],
          name: [item.name],
          isSelected: [item.isSelected],
        })
      );
    });
  }

  atLeastOneCheckedValidator: ValidatorFn = (
    control: AbstractControl
  ): ValidationErrors | null => {
    const formArray = control as FormArray;
    return formArray.controls.some(c => c.get('isSelected')?.value)
      ? null
      : { atLeastOneRequired: true };
  };

  edit(): void {
    this.isEditMode = true;
    this.form.enable();
  }

  save(): void {
    if (this.form.invalid) return;

    const websites = this.form.getRawValue().websites;
    const payload = {
      customerId: this.customerId,
      cvBoxProviderSelections: websites
    }
    this.customerService
      .saveCvBoxChannels(this.customerId, payload)
      .subscribe(() => {
        this.providerWebsites = payload.cvBoxProviderSelections;
        this.isEditMode = false;
        this.form.disable();
      });
  }

  cancel(): void {
    this.isEditMode = false;
    this.websites.clear();
    this.setWebsites(this.providerWebsites);
    this.form.disable();
  }
}
